// extracted by mini-css-extract-plugin
export default {"container":"AdviseeList_container__UqAnf","advtable":"AdviseeList_advtable__FVqCh"};